<template>
  <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      @keydown.enter.prevent="save"
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
        :style="{ height: dialogHeight + 'px' }"
    >
      <v-card-title>
        <span class="headline">Reward Config</span>
      </v-card-title>
      <v-card-text class="resizable-card__body">
        <v-row dense class="mt-4">
          <v-col cols="12" md="6" sm="6">
            <v-text-field
                label="Key"
                v-model.trim="model.key"
                v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="2" sm="2" v-if="config.days">
            <v-text-field label="Days" v-model.number="model.points"/>
          </v-col>
          <v-col cols="12" md="2" sm="2" v-if="config.points">
            <v-text-field label="Points" v-model.number="model.points"/>
          </v-col>
          <v-col cols="12" md="2" sm="2" v-if="config.percent">
            <v-slider v-model="model.percent" label="Percent" thumb-label/>
          </v-col>
          <v-col cols="12" md="4" sm="4" v-if="config.productGroups.length>0">
            <r-product-dropdown :model.sync="model.product" :groups="config.productGroups" :clearable="true"/>
          </v-col>
        </v-row>
        <v-row dense>
          <r-reward-view :model.sync="model"/>
        </v-row>
      </v-card-text>
      <v-card-actions class="resizable-card__actions">
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
      <div class="resize-handle" @mousedown="startResize"></div>
    </v-card>
  </v-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";
import RRewardView from "@/modules/redactor/views/reward/r-reward-view.vue";
import RProductDropdown from "@/modules/redactor/views/product/r-product-dropdown.vue";

export default {
  name: "r-reward-bunch-dialog",
  components: {RProductDropdown, RRewardView},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new RewardModel(),
    config: {
      days: false,
      points: false,
      percent: false,
      productGroups: []
    },
    rules: ViewRules.READONLY,
    dialogWidth: 575,
    dialogHeight: 338,
    resizing: false,
    resizeStartX: 0,
    resizeStartY: 0,
    resizeStartWidth: 575,
    resizeStartHeight: 338,
    viewportPadding: 32
  }),
  methods: {
    show(rules, model, config) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new RewardModel();
      this.config = config || {
        days: false,
        points: false,
        percent: false,
        productGroups: []
      };
      console.log(this.config);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (!this.model.empty() && this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
      this.stopResize();
    },
    startResize(e) {
      this.resizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.dialogWidth;
      this.resizeStartHeight = this.dialogHeight;
      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },
    onResize(e) {
      if (!this.resizing) return;
      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;
      let newWidth = this.resizeStartWidth + dx;
      let newHeight = this.resizeStartHeight + dy;
      const minWidth = 400;
      const minHeight = 220;
      const maxWidth = window.innerWidth - this.viewportPadding;
      const maxHeight = window.innerHeight - this.viewportPadding;
      if (newWidth < minWidth) newWidth = minWidth;
      if (newWidth > maxWidth) newWidth = maxWidth;
      if (newHeight < minHeight) newHeight = minHeight;
      if (newHeight > maxHeight) newHeight = maxHeight;
      this.dialogWidth = newWidth;
      this.dialogHeight = newHeight;
    },
    stopResize() {
      if (!this.resizing) return;
      this.resizing = false;
      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onResize);
    window.removeEventListener("mouseup", this.stopResize);
  }
};
</script>

<style scoped>
.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}
.resizable-card__body {
  flex: 1;
  overflow: auto;
}
.resizable-card__actions {
  flex-shrink: 0;
}
.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}
.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>